(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.SolutionBuilderAgent:mxEnumLiteral
	 * @module mx.SolutionBuilderAgent
	 * @description Displays related object
	 * @param {string} label@ - Optional. Label of the control.
	 * @param {string} entityClassName@ - Name of the Enum class.
	 * @param {object} value= - Reference to the Entity object
	 */

	angular.module('mx.SolutionBuilderAgent').component('mxEnumLiteral', {
		bindings: {
			label: '@',
			value: '<',
			entityClassName: '@',
			icon: '@',
			filter: '@',
			hideOnEmptyValue: '@',
			reserveIconSpace: '@',
			labelPosition: '@',
			valueMinWidth: '@',
			labelMinWidth: '@',
			labelMaxWidth: '@',
			labelColor: '@',
			valueColor: '@',
			iconColor: '@',
			designerMode: '<?',
		},
		require: {
			mxServiceContext: '?^mxServiceContext',
		},
		controller: MxEnumLiteralCtrl,
		controllerAs: 'vm',
		template: [
			'$attrs',
			function (tAttrs) {
				var optmzr = typeof tAttrs.designerMode !== 'undefined' && ('' + tAttrs.designerMode).toLowerCase() !== 'false' ? '' : '::';
				return (
					'<mx-literal ' +
					'ng-if="::vm.dataLoaded" ' +
					'label="{{:: vm.label}}" ' +
					'value="' +
					optmzr +
					'vm.literalValue" ' +
					'icon="{{:: vm.icon}}" ' +
					'hide-on-empty-value="{{::vm.hideOnEmptyValue}}" ' +
					'reserve-icon-space="{{::vm.reserveIconSpace}}" ' +
					'label-position="{{::vm.labelPosition}}" ' +
					'value-min-width="{{::vm.valueMinWidth}}" ' +
					'label-min-width="{{::vm.labelMinWidth}}" ' +
					'label-max-width="{{::vm.labelMaxWidth}}" ' +
					'label-color="{{::vm.labelColor}}" ' +
					'value-color="{{::vm.valueColor}}" ' +
					'icon-color="{{::vm.iconColor}}" ' +
					(typeof tAttrs.designerMode !== 'undefined' ? 'designer-mode="' + tAttrs.designerMode + '" ' : '') +
					'></mx-literal>'
				);
			},
		],
	});

	MxEnumLiteralCtrl.$inject = ['mx.SolutionBuilderAgent.EntityService', '$element', 'mx.app.ColorService', 'mx.app.ThemeService'];

	function MxEnumLiteralCtrl(mxEntityService, $element, colorService, themeService) {
		var vm = this;
		var _value, _filter;

		vm.$onInit = async function () {
			vm.isContrast = (await themeService.getCurrentTheme()).isContrastTheme;

			_filter = vm.filter;
			setValue(vm.value);

			Object.defineProperty(vm, 'value', {
				get: function () {
					return _value;
				},
				set: setValue,
			});

			Object.defineProperty(vm, 'filter', {
				get: function () {
					return _filter;
				},
				set: function (value) {
					_filter = value;
				},
			});
		};

		vm.$postLink = function () {
			$element.addClass('mx-literal');
		};

		function processEmptyData() {
			vm.literalValue = '-';
			vm.dataLoaded = vm.hideOnEmptyValue !== 'true';
		}

		function setValue(newVal) {
			if (_value === newVal) {
				return;
			}
			_value = newVal;

			if (vm.entityClassName && _value !== null && _value !== undefined) {
				var enumRequestPromise = vm.mxServiceContext
					? vm.mxServiceContext.$servicePromise.then(function (service) {
							return service.isService && (service.EnumNames.indexOf(vm.entityClassName) !== -1 || _.find(service.EnumTypes, { Name: vm.entityClassName }))
								? service.Enums[vm.entityClassName]
								: mxEntityService.getEnumerationValues(vm.entityClassName, vm.filter);
					  })
					: mxEntityService.getEnumerationValues(vm.entityClassName, vm.filter);

				enumRequestPromise.then(function (enumeration) {
					if (!enumeration) {
						processEmptyData();
						return;
					}

					var res = '';
					var isString = typeof _value === 'string';
					var value = isString && _value.indexOf(',') >= 0 ? _value.split(',') : _value;
					let itemColor;

					var isMultipleValue = Array.isArray(value);

					if (isMultipleValue) {
						value = value.map(function (val) {
							return !isNaN(val) && typeof val === 'string' ? Number(val) : val;
						});
					} else {
						value = !isNaN(_value) && isString ? Number(_value) : _value;
					}

					for (var i = 0; i < enumeration.length; i++) {
						var item = enumeration[i];

						if (isMultipleValue) {
							if (value.indexOf(item.Value) >= 0) {
								if (res) {
									res += ', ';
								}
								res += item.DisplayString;
							}
						} else if (item.Value === value) {
							res = item.DisplayString;
							if (item.Color) {
								itemColor = `#${item.Color.slice(-6)}`;
							}
							break;
						}
					}

					vm.literalValue = res;
					vm.dataLoaded = true;
					if (itemColor) {
						$element[0].style.setProperty(
							'--mx-enum-literal-value-color-from-pickup',
							colorService.enhanceColorContrast(itemColor, undefined, vm.isContrast ? 4.5 : 2)
						);
					}
				}, processEmptyData);
			} else {
				processEmptyData();
			}
		}
	}
})();
